var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.isEditMode
      ? _c("span", [_vm._v(_vm._s(_vm.contacts[_vm.name]))])
      : _vm._e(),
    _vm._v(" "),
    _vm.isEditMode
      ? _c(
          "div",
          { class: { "has-error": !_vm.isValid } },
          [
            _c("div", { staticClass: "group" }, [
              _c(
                "div",
                {
                  class: {
                    "column inputColumn full": true,
                    error: !_vm.isValid,
                  },
                },
                [
                  _vm.type === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contacts[_vm.name],
                            expression: "contacts[name]",
                          },
                        ],
                        staticClass: "usual-label",
                        attrs: { name: _vm.name, type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.contacts[_vm.name])
                            ? _vm._i(_vm.contacts[_vm.name], null) > -1
                            : _vm.contacts[_vm.name],
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.contacts[_vm.name],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.contacts,
                                    _vm.name,
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.contacts,
                                    _vm.name,
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.contacts, _vm.name, $$c)
                            }
                          },
                        },
                      })
                    : _vm.type === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contacts[_vm.name],
                            expression: "contacts[name]",
                          },
                        ],
                        staticClass: "usual-label",
                        attrs: { name: _vm.name, type: "radio" },
                        domProps: {
                          checked: _vm._q(_vm.contacts[_vm.name], null),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.contacts, _vm.name, null)
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contacts[_vm.name],
                            expression: "contacts[name]",
                          },
                        ],
                        staticClass: "usual-label",
                        attrs: { name: _vm.name, type: _vm.type },
                        domProps: { value: _vm.contacts[_vm.name] },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.contacts,
                              _vm.name,
                              $event.target.value
                            )
                          },
                        },
                      }),
                  _vm._v(" "),
                  _c("label", { attrs: { ph: _vm.label, fl: _vm.label } }),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm._t("default"),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }